(function () {
  function initShapeSection(root) {
    if (!root || root.dataset.spHomeShapesReady === 'true') return;

    var grid = root.querySelector('.sp-home-shapes__grid');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.sp-home-shapes__card'));
    var title = root.querySelector('[data-shape-active-title]');
    var bio = root.querySelector('[data-shape-active-bio]');
    var frame = null;

    if (!grid || !cards.length || !title || !bio) return;
    root.dataset.spHomeShapesReady = 'true';

    function syncActiveShape() {
      frame = null;
      var center = grid.scrollLeft + (grid.clientWidth / 2);
      var activeIndex = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, index) {
        var cardCenter = card.offsetLeft + (card.offsetWidth / 2);
        var distance = Math.abs(cardCenter - center);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      cards.forEach(function (card, index) {
        var isActive = index === activeIndex;
        card.classList.toggle('is-active', isActive);
        if (isActive) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });

      title.textContent = cards[activeIndex].dataset.shapeTitle || '';
      bio.textContent = cards[activeIndex].dataset.shapeBio || '';
    }

    function requestSync() {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(syncActiveShape);
    }

    grid.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync, { passive: true });
    window.requestAnimationFrame(syncActiveShape);
  }

  function initAll(scope) {
    var rootScope = scope || document;
    if (rootScope.matches && rootScope.matches('[data-sp-home-shapes]')) initShapeSection(rootScope);
    Array.prototype.forEach.call(rootScope.querySelectorAll('[data-sp-home-shapes]'), initShapeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
